import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { startTroubleshootingWizard, localCallsTroubleshootingWizard } from './LocalCellularTroubleshootingWizardBlockThunk';
import  WizardEnum from './constant/WizardEnum';

const initialState = {
    epiBlockData: {},
    wizardTypeName: '',
    wizardName: '',
    dwhWizardName: '',
    page: '',
    pageContent: {},
    errorType: '',
    subscriber: '',
    ban: '',
    isShowPopup: false,
    isShowExtendedOtpPopup: false,
    details: null,
    mabal:{
        hasMabalPackage: false
    }
};

const localCellularTroubleshootingWizardBlockSlice = createSlice({
  name: 'localCellularTroubleshootingWizardBlock',
  initialState: initialState,
  reducers: {
    resetBlock: (state) => initialState,
    initBlock: {
        reducer: (state, action) => {
            state.epiBlockData = action.payload.epiBlockData;
            state.wizardTypeName = action.payload.wizardTypeName;
            state.wizardName = action.payload.wizardName;
            state.dwhWizardName = action.payload.dwhWizardName;
            state.page = action.payload.page;
        },
        prepare: (action) => {
            let payload = {};
            const epiBlockDataObj = action.epiBlockData;
            let wizardTypeName = null;
            let wizardName = "";
            let dwhWizardName = "";

            switch (epiBlockDataObj.cellularTroubleshootingType.value) {
                case null:
                case 0:
                    wizardTypeName = WizardEnum.LocalData;
                    wizardName = "אשף תקלת גלישה סלולר בארץ";
                    dwhWizardName = "LocalDataGuide";
                    break;
                case 1:
                    wizardTypeName =  WizardEnum.LocalCalls;
                    wizardName = "אשף תקלת שיחות סלולר בארץ";
                    dwhWizardName = "LocalCallsGuide";
                    break;
                case 2:
                    wizardTypeName = WizardEnum.LocalMabal;
                    wizardName = "אשף תקלת שיחות סלולר מהארץ לחו\"ל";
                    dwhWizardName = "InternationalCallsGuide";
                    break;
                default:
                    wizardTypeName = WizardEnum.LocalData;
                    wizardName = "אשף תקלת גלישה סלולר בארץ";
                    dwhWizardName = "LocalDataGuide";
            }

            let epiBlockData = {
                blockId: epiBlockDataObj.contentLink.id,
                wizardType: epiBlockDataObj.cellularTroubleshootingType.value,
                loaderImage: epiBlockDataObj.loaderImage.value?.url,
                callBackSubjectCode: epiBlockDataObj.callBackSubjectCode.value,
                memoCode: epiBlockDataObj.memoCode.value,
                callBackText: epiBlockDataObj.callBackText.value,
                finalButtonText: epiBlockDataObj.finalButtonText.value,
                finalButtonLink: epiBlockDataObj.finalButtonLink.value,
                browsing: {
                    browsingConnectingToNetworkText: epiBlockDataObj.browsingConnectingToNetworkText.value,
                    browsingConnectingToNetworkLink: epiBlockDataObj.browsingConnectingToNetworkLink.value,
                    unblockBrowsingText: epiBlockDataObj.unblockBrowsingText.value,
                    unblockBrowsingLink: epiBlockDataObj.unblockBrowsingLink.value,
                    purchasingBrowsingPackageText: epiBlockDataObj.purchasingBrowsingPackageText.value,
                    purchasingBrowsingPackageLink: epiBlockDataObj.purchasingBrowsingPackageLink.value,
                    browsingSmartWizardNotFoundErrorText: epiBlockDataObj.browsingSmartWizardNotFoundErrorText.value,
                    browsingSmartWizardNotFoundErrorLink: epiBlockDataObj.browsingSmartWizardNotFoundErrorLink.value,
                    browsingLobbyCellularIssuesAbroadText: epiBlockDataObj.browsingLobbyCellularIssuesAbroadText.value,
                    browsingLobbyCellularIssuesAbroadLink: epiBlockDataObj.browsingLobbyCellularIssuesAbroadLink.value,
                },
                calls: {
                    callsConnectingToNetworkText: epiBlockDataObj.callsConnectingToNetworkText.value,
                    callsConnectingToNetworkLink: epiBlockDataObj.callsConnectingToNetworkLink.value,
                    smartWizardToDeviceRedirectionSettingsText: epiBlockDataObj.smartWizardToDeviceRedirectionSettingsText.value,
                    smartWizardToDeviceRedirectionSettingsLink: epiBlockDataObj.smartWizardToDeviceRedirectionSettingsLink.value,
                    unblockCallsText: epiBlockDataObj.unblockCallsText.value,
                    unblockCallsLink: epiBlockDataObj.unblockCallsLink.value,
                    callsSmartWizardNotFoundErrorText: epiBlockDataObj.callsSmartWizardNotFoundErrorText.value,
                    callsSmartWizardNotFoundErrorLink: epiBlockDataObj.callsSmartWizardNotFoundErrorLink.value,
                    callsLobbyCellularIssuesAbroadText: epiBlockDataObj.callsLobbyCellularIssuesAbroadText.value,
                    callsLobbyCellularIssuesAbroadLink: epiBlockDataObj.callsLobbyCellularIssuesAbroadLink.value,
                },
                mabal: {
                    purchasingMabalText: epiBlockDataObj.purchasingMabalText.value,
                    purchasingMabalLink: epiBlockDataObj.purchasingMabalLink.value,
                    dialingInstructions: epiBlockDataObj.dialingInstructions.value,
                }
            };

            payload.epiBlockData = epiBlockData;
            payload.wizardTypeName = wizardTypeName;
            payload.wizardName = wizardName;
            payload.dwhWizardName = dwhWizardName;
            payload.page = '';
            return { payload: payload };
        },
    },
    reportDWH: (state, action) => { },
    goToPage: (state, action) => {
        state.page = action.payload.page;
        state.pageContent = action.payload.pageContent ?? {};
        window.scrollTo(0, 0);
    },
    setSubscriber: (state, action) => {
        state.subscriber = action.payload.subscriber;
        state.ban = action.payload.ban;
    },
    setIsShowPopup:(state, action) => {
        state.isShowPopup = action.payload;
    },
    setIsShowExtendedOtpPopup:(state, action) => {
        state.isShowExtendedOtpPopup = action.payload;
    },
  },
  extraReducers: {
    [startTroubleshootingWizard.fulfilled]: (state, action) => {
        if (!action.payload) {
            return;
        }
        state.details = action.payload.Body.data;
        state.resultMessage = action.payload.Body.resultMessage;
    },
    [localCallsTroubleshootingWizard.fulfilled]: (state, action) => {
        if (!action.payload) {
            return;
        }
        state.details = action.payload.Body.data;
        state.resultMessage = action.payload.Body.resultMessage;
    },
  },
});

export const {
    resetBlock,
    initBlock,
    reportDWH,
    goToPage,
    setSubscriber,
    setIsShowPopup,
    setIsShowExtendedOtpPopup
} = localCellularTroubleshootingWizardBlockSlice.actions;

export default localCellularTroubleshootingWizardBlockSlice.reducer;


function getWizardTypeName(wizardType) {
    switch (wizardType) {
        case null:
        case 0:
            return WizardEnum.LocalData;
        case 1:
            return WizardEnum.LocalCalls;
        case 2:
            return WizardEnum.LocalMabal;
        default:
            return WizardEnum.LocalData;
    }
}
